import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet, Router } from '@angular/router';
import { DialogRef } from '../../services/modal.service';

import { I18nTranslator } from '../../i18n/translate';
import { Campaign } from '../../models/campaign.model';
import { CampaignYearPipe } from '../../pipes/campaignYear.pipe';
import { CampaignService } from '../../services/campaign.service';
import { ExportsService } from '../../services/exports.service';
import { currentDateFormatted } from '../../utils/utils';
import { COMPANY_NAME, PRODUCT_NAME } from '../../utils/env';
import { ExportsComponent } from './exports';

import { saveAs } from 'file-saver';
import { TranslateWithPunctuationPipe, TranslatePipe } from '../../pipes/translate.pipe';
import { FormsModule } from '@angular/forms';

export class ExportResultsDialogContext {
  parent: ExportsComponent;
}

@Component({
  standalone: true,
  selector: 'export-results-dlg',
  templateUrl: 'export-results-dialog.component.html',
  providers: [CampaignService, ExportsService],
  imports: [RouterLink, RouterLinkActive, RouterOutlet, CommonModule, CampaignYearPipe, TranslateWithPunctuationPipe, TranslatePipe, FormsModule],
})
export class ExportResultsDialogComponent implements OnInit {
  productName = PRODUCT_NAME;
  error: any;
  context: ExportResultsDialogContext;
  campaigns: Campaign[];

  campaignExportId: number;

  constructor(
    public dialog: DialogRef<ExportResultsDialogContext>,
    private campaignService: CampaignService,
    private exportsService: ExportsService,
    private i18nTranslator: I18nTranslator,
    private router: Router,
  ) {
    this.context = dialog.context;
  }

  ngOnInit() {
    this.campaignService.getCampaigns().subscribe((x) => {
      this.handleCampaigns(x);
    });
  }

  handleCampaigns(campaigns: Campaign[]) {
    this.campaigns = campaigns.sort(Campaign.compare).reverse();

    if (this.campaigns.length > 0) {
      this.campaignExportId = this.campaigns[0].id;
    }
  }

  download() {
    this.exportsService.downloadResults(this.campaignExportId).subscribe(
      (res) => {
        const dateFormatted = currentDateFormatted('', false);
        const company_name = COMPANY_NAME.replace(/ /g, '_').toUpperCase();
        const fileNamePart = this.i18nTranslator.translate('exports.resultats.fileName.part');
        const fileName = fileNamePart + '_' + company_name + '_' + dateFormatted + '.xlsx';
        saveAs(res, fileName);

        this.dialog.close();
      },
      (error) => {
        this.dialog.close();

        const msg = this.i18nTranslator.translate('exports.error.telecharger');
        this.context.parent.handleError(error, msg);
      },
    );
  }

  dismiss() {
    this.dialog.close();
  }
}
